import { on, createReducer, createFeature, createSelector } from '@ngrx/store'
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { MenuDefinition } from './menus.model'
import * as actions from './menus.actions'

export interface MenuState extends EntityState<MenuDefinition> {}

export const menuAdapter: EntityAdapter<MenuDefinition> = createEntityAdapter<MenuDefinition>()

export const menusInitialState: MenuState = menuAdapter.getInitialState({
    ids: [
        0, 1, 2, 4, 5, 6, 7
    ],
    entities: [
        {
            id: 0,
            title: "News & Reports",
            area: "news",
            expanded: false,
            columns: {
                aShortCuts: {
                    title: 'Quick Links',
                    template: 'prominent',
                    children: [
                        {
                            id:     -3,
                            icon:   "box-arrow-up-right",
                            link:   "/news/",
                            title:  "Bankruptcy Case News",
                            params: {
                                title:  "Bankruptcy Case News",
                                'Situations':"1",
                            },
                        },
                        {
                            id:     -2,
                            icon:   "box-arrow-up-right",
                            link:   "/news/",
                            title:  "Distressed Company News",
                            params: {
                                title:  "Distressed Company News",
                                'Situations':"2",
                            },
                        },
                        {
                            id:     -1,
                            icon:   "box-arrow-up-right",
                            link:   "/news/",
                            title:  "All News",
                            params: {
                                x:  1,
                            },
                        },

                    ],
                },
                reports: {
                    title: 'Reports',
                    template: 'prominent',
                    children: [
                        {
                            id:     -3,
                            icon:   "box-arrow-up-right",
                            link:   "/reports/",
                            title:  "Advisory Mandates",
                            params: {
                                title:  "Advisory Mandates",
                                'reportType':"1",
                            },
                        },
                        {
                            id:     -4,
                            icon:   "box-arrow-up-right",
                            link:   "/reports/",
                            title:  "BDC Reports",
                            params: {
                                title:  "BDC Reports",
                                'reportType':"8",
                            },
                        },
                        {
                            id:     -2,
                            icon:   "box-arrow-up-right",
                            link:   "/reports/",
                            title:  "Distress Tear Sheets",
                            params: {
                                title:  "Distress Tear Sheets",
                                'reportType':"6",
                            },
                        },
                        {
                            id:     -5,
                            icon:   "box-arrow-up-right",
                            link:   "/reports/",
                            title:  "Spotlights",
                            params: {
                                title:  "Spotlights",
                                'reportType':"9",
                            },
                        },
                        {
                            id:     -1,
                            icon:   "box-arrow-up-right",
                            link:   "/reports/",
                            title:  "All Reports",
                            params: {
                                x:  1,
                            },
                        }
                    ],
                },
                recentNews: {
                    title: 'Recent News',
                    children: [],
                    template: 'featured'
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
        {
            id: 1,
            title: "Situations",
            area: "situations",
            expanded: false,
            columns: {
                aShortCuts: {
                    title: 'Quick Links',
                    template: 'prominent',
                    children: [
                        {
                            id:     -2,
                            icon:   "box-arrow-up-right",
                            link:   "/situations/",
                            title:  "Priority Bankruptcy Cases",
                            params: {
                                title:  "Priority Cases",
                                situation_type:"bankruptcy",
                            }
                        },
                        {
                            id:     -3,
                            icon:   "box-arrow-up-right",
                            link:   "/situations/",
                            title:  "All Bankruptcy Cases",
                            params: {
                                title:  "Bankruptcy Cases",
                                situation_type:"bankruptcy",
                                case_include_type:"non-priority",
                            }
                        },
                        {
                            id:     -4,
                            icon:   "box-arrow-up-right",
                            link:   "/situations/",
                            title:  "All Distress",
                            params: {
                                title:  "All Distress",
                                situation_type:"distressed"
                            }
                        },
                        {
                            id:     -5,
                            icon:   "box-arrow-up-right",
                            link:   "/situations/",
                            title:  "Midmarket Companies",
                            params: {
                                title:  "Midmarket Companies",
                                situation_type:"bankruptcy,distressed",
                                liabilities_range:"10000001-50000000,50000001-100000000,100000001-500000000",
                                case_include_type:"non-priority",

                            }
                        },
                        {
                            id:     -1,
                            link:   "/situations/",
                            title:  "All Situations",
                            params: {
                            }
                        },
                    ]
                },
                recentBankruptcies: {
                    title: 'Recent Bankruptcies',
                    children: [],
                    template: 'featured'
                },
                recentDistressed: {
                    title: 'Recent Distressed',
                    children: [],
                    template: 'featured'
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
        {
            id: 2,
            title: 'Data Sets',
            link: '/data',
            area: "data",
            expanded: false,
            columns: {
                dataSets: {
                    title: 'Data Sets',
                    template: 'prominent',
                    children: [
                        {
                            link: '/situations',
                            title: 'Bankruptcy Cases',
                            params: {
                                title:  "Bankruptcy Cases",
                                situation_type: "bankruptcy"
                            }
                        },
                        {
                            link: '/data/archive',
                            title: 'Archive',
                        },
                        {
                            link: '/data/asset-sales',
                            title: 'Asset Sales',
                        },
                        {
                            link: '/data/calendar',
                            title: 'Calendar',
                        },
                        {
                            link: '/data/creditors',
                            title: 'Creditors',
                        },
                        {
                            link: '/data/groups',
                            title: 'Groups',
                        },
                        {
                            link: '/data/instruments',
                            title: 'Instruments',
                        },
                        {
                            link: '/data/keip-kerp',
                            title: 'KEIP/KERPs',
                        },
                        {
                            link: '/data/plans',
                            title: 'Plans',
                        },
                        {
                            link: '/data/real-property',
                            title: 'Real Property',
                            hasAI: true,
                        },
                        {
                            link: '/data/retentions',
                            title: 'Retentions/Fees',
                        },
                        {
                            link: '/data/rights-offerings',
                            title: 'Rights Offerings',
                        },
                    ]
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
        {
            id: 3,
            title: 'Analytics',
            link: '/analytics',
            area: "anayltics",
            expanded: false,
            columns: [],
            version: 0
        },
        {
            id: 4,
            title: 'Organizations',
            link: '/organizations',
            area: "organizations",
            expanded: false,
            columns: {
                organizations: {
                    title: 'Organizations',
                    template: 'prominent',
                    children: [
                        {
                            link: '/organizations',
                            title: 'Distressed Corporates',
                            params: {
                                title:  'Distressed Corporates',
                                involvementgraphs: "1",
                            },
                        },
                        {
                            link: '/organizations',
                            title: 'Legal Advisors',
                            params: {
                                title:  "Legal Advisors",
                                involvementgraphs:"6",
                                involvement_subtype_lookupID_advisor: "16",
                            },
                        },
                        {
                            link: '/organizations',
                            title: 'Financial Advisors',
                            params: {
                                title:  "All Advisors",
                                involvementgraphs:"6",
                                involvement_subtype_lookupID_advisor: "21",
                            },
                        },
                        {
                            link: '/organizations',
                            title: 'All Advisors',
                            params: {
                                title:  "All Advisors",
                                'involvementgraphs':"6",
                            },
                        },
                        {
                            link: '/organizations',
                            title: 'All Creditors',
                            params: {
                                title:  "All Creditors",
                                'involvementgraphs':"11_21_26_56",
                            },
                        },
                        {
                            link: '/organizations',
                            title: 'All Organizations',
                            params: {}
                        },
                    ]
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
        {
            id: 5,
            title: 'People',
            link: '/people',
            area: "people",
            expanded: false,
            columns: {
                dataSets: {
                    title: 'People',
                    template: 'prominent',
                    children: [
                        {
                            link: '/people',
                            title: 'Officers',
                            params: {
                                title:  'Officers',
                                involvementgraphs: "16",
                                'involvement_subtype_lookupID_staff': "1",
                            },
                        },
                        {
                            link: '/people',
                            title: 'Advisors',
                            params: {
                                title:  "Advisors",
                                involvementgraphs:"6",
                            },
                        },
                        {
                            link: '/people',
                            title: 'Creditors',
                            params: {
                                title:  "Creditors",
                                involvementgraphs:"11_21_26_56",
                            },
                        },
                        {
                            link: '/people',
                            title: 'Judges',
                            params: {
                                title:  "Judges",
                                'involvementgraphs':"71",
                            },
                        },
                        {
                            link: '/people',
                            title: 'Court Appointees',
                            params: {
                                title:  "Court Appointees",
                                'involvementgraphs':"31",
                            },
                        },
                        {
                            link: '/people',
                            title: 'All People',
                            params: {},
                        },
                    ]
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
        {
            id: 6,
            title: 'League Tables',
            //badge: 'New',
            link: '/league-tables',
            area: "league-tables",
            expanded: false,
            columns: {
                advisorLeagueTables: {
                    title: 'Advisor League Tables',
                    template: 'prominent',
                    children: [
                        {
                            id:     -6,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Legal Advisors",
                            params: {
                                tab: 1,
                            },
                        },
                        {
                            id:     -5,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Financial Advisors",
                            params: {
                                tab: 2,
                            },
                        },
                        {
                            id:     -4,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Restructuring/Turnaround Advisors",
                            params: {
                                tab: 3,
                            },
                        },
                        {
                            id:     -3,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Claims/Notice Agents",
                            params: {
                                tab: 4,
                            },
                        },
                        {
                            id:     -2,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Other Advisors",
                            params: {
                                tab: 5,
                            },
                        },
                    ],
                },
                otherLeagueTables: {
                    title: 'Other League Tables',
                    template: 'prominent',
                    children: [
                        {
                            id:     -6,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Group Members",
                            params: {
                                tab: 6,
                            },
                        },
                        {
                            id:     -5,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Funded Debtholders",
                            params: {
                                tab: 7,
                            },
                        },
                        {
                            id:     -4,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Trade Exposure",
                            params: {
                                tab: 8,
                            },
                        },
                    ],
                },
                popularLeagueTables: {
                    title: 'Popular League Tables',
                    template: 'prominent',
                    children: [
                        {
                            id:     -16,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Debtor Bankruptcy Counsel",
                            params: {
                                tab: 1,
                                "involvement_role_lookupID": "156",
                                "advisee_group_participation": "individuals",
                                "involvement_type_lookupID_situationadvisee": "1",
                                "situation_type": "bankruptcy",
                            },
                        },
                        {
                            id:     -15,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "UCC Bankruptcy Counsel",
                            params: {
                                tab: 1,
                                "involvement_role_lookupID": "156",
                                "advisee_group_participation":  "groups" ,
                                "advisee_group_type": "group-official",
                                "advisee_group_debt_type": "group-unsecured",
                                "situation_type": "bankruptcy" ,
                            },
                        },
                        {
                            id:     -14,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "Debtor Financial Advisors",
                            params: {
                                tab: 2,
                                "involvement_role_lookupID": "201",
                                "advisee_group_participation": "individuals",
                                "involvement_type_lookupID_situationadvisee": "1",
                                "situation_type": "bankruptcy" ,
                            },
                        },
                        {
                            id:     -13,
                            icon:   "box-arrow-up-right",
                            link:   "/league-tables/",
                            title:  "UCC Financial Advisors",
                            params: {
                                tab: 2,
                                "involvement_role_lookupID": "201",
                                "advisee_group_participation": "groups",
                                "advisee_group_type": "group-official",
                                "advisee_group_debt_type": "group-unsecured",
                                "situation_type": "bankruptcy",
                            },
                        },
                    ]
                },
            },
            version: 0
        },
        {
            id: 7,
            title: 'Documents',
            area: "documents",
            link: '/documents',
            columns: {
                documentsCourt: {
                    title: 'Court Documents',
                    template: 'prominent',
                    children: [
                        {
                            link: '/documents',
                            title: 'Petition',
                            params: {
                                title:  'Petition',
                                documenttypes: 4
                            },
                        },
                        {
                            link: '/documents',
                            title: '363 Sales',
                            params: {
                                title:  '363 Sale/Asset Purchase Agreement',
                                documenttypes: 3
                            },
                        },
                        {
                            link: '/documents',
                            title: 'KEIP/KERP',
                            params: {
                                title:  'KEIP/KERP',
                                documenttypes: 10
                            },
                        },
                        {
                            link: '/documents',
                            title: 'Plans and Disclosure Statements',
                            params: {
                                title:  'Plans and Disclosure Statements',
                                documenttypes: '6,14'
                            },
                        },
                        {
                            link: '/documents',
                            title: 'All Documents',
                            params: {}
                        },
                    ]
                },
                documentssec: {
                    title: 'SEC Documents',
                    template: 'prominent',
                    children: [
                        {
                            link: '/secdocuments',
                            title: '10K Annual Reports',
                            params: {
                                title:  '10-K Annual Reports',
                                formname: "10-K:10-K Annual Reports"
                            },
                        },
                        {
                            link: '/secdocuments',
                            title: '10Q Quarterly Reports',
                            params: {
                                title:  '10-Q Quarterly Reports',
                                formname: "10-Q:10-Q Quarterly Reports"
                            },
                        },
                        {
                            link: '/secdocuments',
                            title: '8-K Current Reports',
                            params: {
                                title:  '8-K Current Reports',
                                formname: "8-K:8-K Current Reports"
                            },
                        },
                        {
                            link: '/secdocuments',
                            title: 'All Documents',
                            params: {}
                        },
                    ]
                },
                searches: {
                    title: 'Searches',
                    children: [],
                    template: 'search'
                },
            },
            version: 0
        },
    ]
})

const {
    selectAll
} = menuAdapter.getSelectors()

export const selectAllMenusAdapter = selectAll

export const menusFeature = createFeature({
    name: 'menus',
    reducer: createReducer(
        menusInitialState,

        on(actions.loadMenus, (state, { menus }) => {
            for (const menuUpdate of menus) {
                state = menuAdapter.mapOne({
                    id: menuUpdate.id,
                    map: (menu : MenuDefinition) => {
                        let newMenu = structuredClone(menu)
                        newMenu.version = menuUpdate.version

                        for ( const [ menuKey, menuColumn] of Object.entries(menuUpdate.columns!)) {
                            newMenu.columns![menuKey].children = menuColumn.children
                        }
                        return newMenu
                    }
                }, state)
            }
            return state
        }),
        on(actions.updateMenuExpansion, (state, menu) => {
            return menuAdapter.updateOne(menu, state)
        }),
        on(actions.closeMegaMenus, (state) => {
            return menuAdapter.map( menu => {
                return {
                    ...menu,
                    expanded: false
                }
            }, state)
        }),
        on(actions.resetMegaMenus, (state) => {
            return menusInitialState
        })
    ),
    extraSelectors: ({ selectMenusState }) => ({
        selectAllMenus: createSelector(
            selectMenusState,
            selectAllMenusAdapter
        )
    })
})

export const {
    selectAllMenus
} = menusFeature
